import React from "react";

export default function SQL_Full_Join() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Full_Join</h1>
      <p>This is the SQL_Full_Join component generated from the SQL JSON.</p>
    </div>
  );
}
